module.exports = __webpack_public_path__ + "img/public_popup_wholemode_close.5de241cb.svg";